import { Helmet } from 'react-helmet-async'

interface SEOProps {
  title?: string
  description?: string
  image?: string
}

export default function SEO({ 
  title = 'VeteranOS - Veteran Transition OS',
  description = 'Your transition HQ from MOS to remote software engineering',
  image = 'https://lovable.dev/opengraph-image-p98pqg.png'
}: SEOProps) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@Lovable" />
      <meta name="twitter:image" content={image} />
    </Helmet>
  )
}
